// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__A7FAx","verticalPadding":"Container_verticalPadding__oQVCm","horizontalPadding":"Container_horizontalPadding__NrU5A"};